<template>
  <div class="container px-1" v-if="website.id">
    <div class="">
      <div
        class="ba-flex ba-jc-sb ba-gp-1"
      >
        <div class="ba-flex ba-gp-04 ba-ai-center">
          <label class='ba-switch ba-sm' @click="applyGDPRChanges">
              <input type='checkbox' class='ba-checkbox' v-model="active">
              <span class='ba-slider'></span>
          </label>
          <span>{{ $t("ct-gdpr-active") }}</span>
        </div>
        <div class="ba-flex ba-gp-1 ba-ai-center">
          <button class="ba-btn ba-dark ba-md" @click.prevent="reloadLanguage()">
            {{$t('ct-gdpr-reload-language')}}
          </button>
          <button
            class="ba-btn ba-blue ba-md"
            @click.prevent="saveSettings(website)"
          >
            {{ $t("ct-save") }}
          </button>
        </div>
      </div>
      <hr v-if="active">
      <div v-if="active">
        <div class="card-content">
          <p>{{ $t("ct-gdpr-colors-and-position") }}</p>

          <div class="row">
            <div class="col-md-3 form-group ba-box-input">
              <label for="CPposition">{{ $t("ct-gdpr-position") }}</label>
              <select
              class='ba-select ba-md'
                v-model="position"
                @change="applyGDPRChanges"
                id="CPposition"
              >
                <option value="top-left">
                  {{ $t("ct-gdpr-position-top-left") }}
                </option>
                <option value="top-right">
                  {{ $t("ct-gdpr-position-top-right") }}
                </option>
                <option value="full-top">
                  {{ $t("ct-gdpr-position-full-top") }}
                </option>
                <option value="center-center">
                  {{ $t("ct-gdpr-position-center-center") }}
                </option>
                <option value="bottom-left">
                  {{ $t("ct-gdpr-position-bottom-left") }}
                </option>
                <option value="bottom-right">
                  {{ $t("ct-gdpr-position-bottom-right") }}
                </option>
                <option value="full-bottom">
                  {{ $t("ct-gdpr-position-full-bottom") }}
                </option>
              </select>
            </div>
          </div>

          <div class="row">
            <div class="form-group col-md-3">
              <label for="pickerbackgroundColor">
                {{ $t("ct-gdpr-background-color") }}
              </label>
              <div
                class="colorpicker"
                id="pickerbackgroundColor"
                @click="togglePicker('displayPickerbackgroundColor')"
              >
                <div>
                  <div
                    :style="'background-color: ' + backgroundColor + ';'"
                  ></div>
                </div>
                <span>{{ backgroundColor }}</span>
              </div>
              <sketch-picker
                v-show="displayPickerbackgroundColor"
                :color="backgroundColor"
                v-model="backgroundColor"
                @input="changeValue($event, 'backgroundColor')"
              />
            </div>

            <div class="form-group col-md-3">
              <label for="pickercolorTitle">
                {{ $t("ct-gdpr-color-title") }}
              </label>
              <div
                class="colorpicker"
                id="pickercolorTitle"
                @click="togglePicker('displayPickercolorTitle')"
              >
                <div>
                  <div :style="'background-color: ' + colorTitle + ';'"></div>
                </div>
                <span>{{ colorTitle }}</span>
              </div>
              <sketch-picker
                v-show="displayPickercolorTitle"
                :color="colorTitle"
                v-model="colorTitle"
                @input="changeValue($event, 'colorTitle')"
              />
            </div>

            <div class="form-group col-md-3">
              <label for="pickercolorParagraph">
                {{ $t("ct-gdpr-color-paragraph") }}
              </label>
              <div
                class="colorpicker"
                id="pickercolorParagraph"
                @click="togglePicker('displayPickercolorParagraph')"
              >
                <div>
                  <div
                    :style="'background-color: ' + colorParagraph + ';'"
                  ></div>
                </div>
                <span>{{ colorParagraph }}</span>
              </div>
              <sketch-picker
                v-show="displayPickercolorParagraph"
                :color="colorParagraph"
                v-model="colorParagraph"
                @input="changeValue($event, 'colorParagraph')"
              />
            </div>

            <div class="form-group col-md-3">
              <label for="pickercolorLink">
                {{ $t("ct-gdpr-color-link") }}
              </label>
              <div
                class="colorpicker"
                id="pickercolorLink"
                @click="togglePicker('displayPickercolorLink')"
              >
                <div>
                  <div :style="'background-color: ' + colorLink + ';'"></div>
                </div>
                <span>{{ colorLink }}</span>
              </div>
              <sketch-picker
                v-show="displayPickercolorLink"
                :color="colorLink"
                v-model="colorLink"
                @input="changeValue($event, 'colorLink')"
              />
            </div>

            <div class="form-group col-md-3">
              <label for="pickerbuttonBackground">
                {{ $t("ct-gdpr-button-background") }}
              </label>
              <div
                class="colorpicker"
                id="pickerbuttonBackground"
                @click="togglePicker('displayPickerbuttonBackground')"
              >
                <div>
                  <div
                    :style="'background-color: ' + buttonBackground + ';'"
                  ></div>
                </div>
                <span>{{ buttonBackground }}</span>
              </div>
              <sketch-picker
                v-show="displayPickerbuttonBackground"
                :color="buttonBackground"
                v-model="buttonBackground"
                @input="changeValue($event, 'buttonBackground')"
              />
            </div>

            <div class="form-group col-md-3">
              <label for="pickerbuttonColor">
                {{ $t("ct-gdpr-button-color") }}
              </label>
              <div
                class="colorpicker"
                id="pickerbuttonColor"
                @click="togglePicker('displayPickerbuttonColor')"
              >
                <div>
                  <div :style="'background-color: ' + buttonColor + ';'"></div>
                </div>
                <span>{{ buttonColor }}</span>
              </div>
              <sketch-picker
                v-show="displayPickerbuttonColor"
                :color="buttonColor"
                v-model="buttonColor"
                @input="changeValue($event, 'buttonColor')"
              />
            </div>

            <div class="form-group col-md-3">
              <label for="pickerbuttonAdvBackground">
                {{ $t("ct-gdpr-button-advanced-bg") }}
              </label>
              <div
                class="colorpicker"
                id="pickerbuttonAdvBackground"
                @click="togglePicker('displayPickerbuttonAdvBackground')"
              >
                <div>
                  <div
                    :style="'background-color: ' + buttonAdvBackground + ';'"
                  ></div>
                </div>
                <span>{{ buttonAdvBackground }}</span>
              </div>
              <sketch-picker
                v-show="displayPickerbuttonAdvBackground"
                :color="buttonAdvBackground"
                v-model="buttonAdvBackground"
                @input="changeValue($event, 'buttonAdvBackground')"
              />
            </div>

            <div class="form-group col-md-3">
              <label for="pickerbuttonAdvColor">
                {{ $t("ct-gdpr-button-advanced-color") }}
              </label>
              <div
                class="colorpicker"
                id="pickerbuttonAdvColor"
                @click="togglePicker('displayPickerbuttonAdvColor')"
              >
                <div>
                  <div
                    :style="'background-color: ' + buttonAdvColor + ';'"
                  ></div>
                </div>
                <span>{{ buttonAdvColor }}</span>
              </div>
              <sketch-picker
                v-show="displayPickerbuttonAdvColor"
                :color="buttonAdvColor"
                v-model="buttonAdvColor"
                @input="changeValue($event, 'buttonAdvColor')"
              />
            </div>
          </div>
        </div>
        <hr />

        <div class="card-content">
          <p>{{ $t("ct-gdpr-texts") }}</p>

          <div class="row">
            <div class="form-group col-md-6 ba-box-input">
              <label for="title">{{ $t("ct-gdpr-title") }}</label>
              <input
                id="title"
                v-model="title"
                class="ba-input ba-md"
                @change="applyGDPRChanges"
                maxlength="40"
              />
            </div>
            <div class="form-group col-8 col-md-3 ba-box-input">
              <label for="fontFamily">{{ $t("ct-font") }}</label>
              <select
                id="fontFamily"
                class="ba-select ba-md"
                v-model="fonts.title.fontFamily"
              >
                <option
                  v-for="(family, idx) in fontFamilies"
                  :key="idx"
                  :value="family.value"
                  v-text="family.text"
                />
              </select>
            </div>
            <div class="form-group col-4 col-md-3 ba-box-input">
              <label for="titleFontSize">{{ $t("ct-size") }}</label>
              <select
                id="titleFontSize"
                class="ba-select ba-md"
                v-model="fonts.title.fontSize"
              >
                <option
                  v-for="size in fontSizes"
                  :key="size"
                  :value="size"
                  v-text="size"
                />
              </select>
            </div>
          </div>

          <div class="row">
            <div class="form-group col-md-6 ba-box-input">
              <label for="message">{{ $t("ct-gdpr-message") }}</label>
              <textarea
                id="message"
                v-model="message"
                class="ba-textarea"
                @change="applyGDPRChanges"
              ></textarea>
            </div>
            <div class="form-group col-8 col-md-3 ba-box-input">
              <label for="messageFontFamily">{{ $t("ct-font") }}</label>
              <select
                id="messageFontFamily"
                class="ba-select ba-md"
                v-model="fonts.message.fontFamily"
              >
                <option
                  v-for="(family, idx) in fontFamilies"
                  :key="idx"
                  :value="family.value"
                  v-text="family.text"
                />
              </select>
            </div>
            <div class="form-group col-4 col-md-3 ba-box-input">
              <label for="messageFontSize">{{ $t("ct-size") }}</label>
              <select
                id="messageFontSize"
                class="ba-select ba-md"
                v-model="fonts.message.fontSize"
              >
                <option
                  v-for="size in fontSizes"
                  :key="size"
                  :value="size"
                  v-text="size"
                />
              </select>
            </div>
          </div>

          <div class="row">
            <div class="form-group col-md-6 ba-box-input">
              <label for="aceptBtnLabel">{{
                  $t("ct-gdpr-accept-btn-label")
                }}</label>
              <input
                id="aceptBtnLabel"
                v-model="acceptBtnLabel"
                class="ba-input ba-md"
                @change="applyGDPRChanges"
                maxlength="40"
              />
            </div>
            <div class="form-group col-8 col-md-3 ba-box-input">
              <label for="aceptBtnLabelFontFamily">{{ $t("ct-font") }}</label>
              <select
                id="aceptBtnLabelFontFamily"
                class="ba-select ba-md"
                v-model="fonts.acceptBtnLabel.fontFamily"
              >
                <option
                  v-for="(family, idx) in fontFamilies"
                  :key="idx"
                  :value="family.value"
                  v-text="family.text"
                />
              </select>
            </div>
            <div class="form-group col-4 col-md-3 ba-box-input">
              <label for="aceptBtnLabelFontSize">{{ $t("ct-size") }}</label>
              <select
                id="aceptBtnLabelFontSize"
                class="ba-select ba-md"
                v-model="fonts.acceptBtnLabel.fontSize"
              >
                <option
                  v-for="size in fontSizes"
                  :key="size"
                  :value="size"
                  v-text="size"
                />
              </select>
            </div>
          </div>

          <div class="row">
            <div class="form-group col-md-6 ba-box-input">
              <label for="onlyBtnLabel">{{
                  $t("ct-gdpr-only-btn-label")
                }}</label>
              <input
                id="onlyBtnLabel"
                v-model="onlyBtnLabel"
                class="ba-input ba-md"
                @change="applyGDPRChanges"
                maxlength="40"
              />
            </div>
            <div class="form-group col-8 col-md-3 ba-box-input">
              <label for="onlyBtnLabelFontFamily">{{ $t("ct-font") }}</label>
              <select
                id="onlyBtnLabelFontFamily"
                class="ba-select ba-md"
                v-model="fonts.onlyBtnLabel.fontFamily"
              >
                <option
                  v-for="(family, idx) in fontFamilies"
                  :key="idx"
                  :value="family.value"
                  v-text="family.text"
                />
              </select>
            </div>
            <div class="form-group col-4 col-md-3 ba-box-input">
              <label for="onlyBtnLabelFontSize">{{ $t("ct-size") }}</label>
              <select
                id="onlyBtnLabelFontSize"
                class="ba-select ba-md"
                v-model="fonts.onlyBtnLabel.fontSize"
              >
                <option
                  v-for="size in fontSizes"
                  :key="size"
                  :value="size"
                  v-text="size"
                />
              </select>
            </div>
          </div>

          <div class="row">
            <div class="form-group col-md-6 ba-box-input">
              <label for="moreInfoLabel">{{ $t("ct-gdpr-more-info") }}</label>
              <input
                id="moreInfoLabel"
                v-model="moreInfoLabel"
                class="ba-input ba-md"
                @change="applyGDPRChanges"
                maxlength="40"
              />
            </div>
            <div class="form-group col-8 col-md-3 ba-box-input">
              <label for="moreInfoLabelFontFamily">{{ $t("ct-font") }}</label>
              <select
                id="moreInfoLabelFontFamily"
                class="ba-select ba-md"
                v-model="fonts.moreInfoLabel.fontFamily"
              >
                <option
                  v-for="(family, idx) in fontFamilies"
                  :key="idx"
                  :value="family.value"
                  v-text="family.text"
                />
              </select>
            </div>
            <div class="form-group col-4 col-md-3 ba-box-input">
              <label for="moreInfoLabelFontSize">{{ $t("ct-size") }}</label>
              <select
                id="moreInfoLabelFontSize"
                class="ba-select ba-md"
                v-model="fonts.moreInfoLabel.fontSize"
              >
                <option
                  v-for="size in fontSizes"
                  :key="size"
                  :value="size"
                  v-text="size"
                />
              </select>
            </div>
          </div>

          <div class="row">
            <div class="form-group col-md-6 ba-box-input">
              <label for="link">{{ $t("ct-gdpr-more-link") }}</label>
              <input
                id="link"
                v-model="link"
                class="ba-input ba-md"
                @change="applyGDPRChanges"
              />
            </div>
          </div>

          <div class="row">
            <div class="form-group col-md-6 ba-box-input">
              <label for="advancedBtnLabel">{{$t("ct-gdpr-advanced-btn-label")}}</label>
              <input
                id="advancedBtnLabel"
                v-model="advancedBtnLabel"
                class="ba-input ba-md"
                @change="applyGDPRChanges"
                maxlength="40"
              />
            </div>
            <div class="form-group col-8 col-md-3 ba-box-input">
              <label for="advancedBtnLabelFontFamily">{{$t("ct-font")}}</label>
              <select
                id="advancedBtnLabelFontFamily"
                class="form-control ba-input ba-md"
                v-model="fonts.advancedBtnLabel.fontFamily"
              >
                <option
                  v-for="(family, idx) in fontFamilies"
                  :key="idx"
                  :value="family.value"
                  v-text="family.text"
                />
              </select>
            </div>
            <div class="form-group col-4 col-md-3 ba-box-input">
              <label for="advancedBtnLabelFontSize">{{ $t("ct-size") }}</label>
              <select
                id="advancedBtnLabelFontSize"
                class="ba-input ba-md"
                v-model="fonts.advancedBtnLabel.fontSize"
              >
                <option
                  v-for="size in fontSizes"
                  :key="size"
                  :value="size"
                  v-text="size"
                />
              </select>
            </div>
          </div>

          <div class="row">
            <div class="form-group col-md-6 ba-box-input">
              <label for="cookieTypesTitle">{{$t("ct-gdpr-cookie-types-title")}}</label>
              <input
                id="cookieTypesTitle"
                v-model="cookieTypesTitle"
                class="ba-input ba-md"
                @change="applyGDPRChanges"
                maxlength="40"
              />
            </div>
            <div class="form-group col-8 col-md-3 ba-box-input">
              <label for="cookieTypesTitleFontFamily">{{$t("ct-font")}}</label>
              <select
                id="cookieTypesTitleFontFamily"
                class="ba-select ba-md"
                v-model="fonts.cookieTypesTitle.fontFamily"
              >
                <option
                  v-for="(family, idx) in fontFamilies"
                  :key="idx"
                  :value="family.value"
                  v-text="family.text"
                />
              </select>
            </div>
            <div class="form-group col-4 col-md-3 ba-box-input">
              <label for="cookieTypesTitleFontSize">{{ $t("ct-size") }}</label>
              <select
                id="cookieTypesTitleFontSize"
                class="ba-select ba-md"
                v-model="fonts.cookieTypesTitle.fontSize"
              >
                <option
                  v-for="size in fontSizes"
                  :key="size"
                  :value="size"
                  v-text="size"
                />
              </select>
            </div>
          </div>
        </div>
        <hr />

        <div class="card-content">
          <p>{{ $t("ct-gdpr-additional-texts") }}</p>

          <div class="row">
            <div class="col-md-6">
              <p>{{ $t("ct-gdpr-fixed-type") }}</p>
              <div class="form-group ba-box-input">
                <label for="fixedTitle">{{ $t("ct-gdpr-fixed-title") }}</label>
                <input
                  id="fixedTitle"
                  v-model="fixedCookieTypeLabel"
                  class="ba-input ba-md"
                  @change="applyGDPRChanges"
                  maxlength="40"
                />
              </div>
              <div class="form-group ba-box-input">
                <label for="fixedTitleDesc">{{$t("ct-gdpr-fixed-message")}}</label>
                <textarea
                  id="fixedTitleDesc"
                  v-model="fixedCookieTypeDesc"
                  class="ba-textarea"
                  @change="applyGDPRChanges"
                ></textarea>
              </div>
            </div>

            <div class="col-md-6">
              <p>{{ $t("ct-gdpr-preferences-type") }}</p>
              <div class="form-group ba-box-input">
                <label for="preferences">{{$t("ct-gdpr-preferences-title")}}</label>
                <input
                  id="preferences"
                  v-model="cookieTypes.preferences.type"
                  class="ba-input ba-md"
                  @change="applyGDPRChanges"
                  maxlength="40"
                />
              </div>
              <div class="form-group ba-box-input">
                <label for="preferencesDesc">{{$t("ct-gdpr-preferences-message")}}</label>
                <textarea
                  id="preferencesDesc"
                  v-model="cookieTypes.preferences.description"
                  class="ba-textarea"
                  @change="applyGDPRChanges"
                ></textarea>
              </div>
            </div>

            <div class="col-md-6">
              <p>{{ $t("ct-gdpr-analytics-type") }}</p>
              <div class="form-group ba-box-input">
                <label for="analytics">{{$t("ct-gdpr-analytics-title")}}</label>
                <input
                  id="analytics"
                  v-model="cookieTypes.analytics.type"
                  class="ba-input ba-md"
                  @change="applyGDPRChanges"
                  maxlength="40"
                />
              </div>
              <div class="form-group ba-box-input">
                <label for="analyticsDesc">{{$t("ct-gdpr-analytics-message")}}</label>
                <textarea
                  id="analyticsDesc"
                  v-model="cookieTypes.analytics.description"
                  class="ba-textarea"
                  @change="applyGDPRChanges"
                ></textarea>
              </div>
            </div>

            <div class="col-md-6">
              <p>{{ $t("ct-gdpr-marketing-type") }}</p>
              <div class="form-group ba-box-input">
                <label for="marketing">{{$t("ct-gdpr-marketing-title")}}</label>
                <input
                  id="marketing"
                  v-model="cookieTypes.marketing.type"
                  class="ba-input ba-md"
                  @change="applyGDPRChanges"
                  maxlength="40"
                />
              </div>
              <div class="form-group ba-box-input">
                <label for="marketingDesc">{{$t("ct-gdpr-marketing-message")}}</label>
                <textarea
                  id="marketingDesc"
                  v-model="cookieTypes.marketing.description"
                  class="ba-textarea"
                  @change="applyGDPRChanges"
                ></textarea>
              </div>
            </div>
          </div>
        </div>
        <hr>
        <div
          class="ba-flex ba-jc-sb ba-gp-1"
        >
          <div class="ba-flex ba-gp-04 ba-ai-center">
            <label class='ba-switch ba-sm' @click="applyGDPRChanges">
                <input type='checkbox' 
                  class='ba-checkbox'
                  id="checkResetCookies"
                  v-model="activeResetCookies"
                >
                <span class='ba-slider'></span>
            </label>
            <span>{{ $t("ct-gdpr-activeReset") }}</span>
          </div>
          <div>
            <button
              class="ba-btn ba-blue ba-md"
              @click.prevent="saveSettings(website)"
            >
              {{ $t("ct-save") }}
            </button>
          </div>
        </div>
      </div>
      <hr v-if="activeResetCookies && active">
      <div class="card-content pl-md-5" v-if="activeResetCookies && active">
        <p>{{ $t("ct-clear-cookies") }}</p>

        <div class="row">
          <div class="form-group col-md-6 ba-box-input">
            <label for="btnLabelResetCookies">{{$t("ct-gdpr-resetCookies-btn-label")}}</label>
            <input
              id="btnLabelResetCookies"
              v-model="btnLabelResetCookies"
              class="ba-input ba-md"
              @change="applyGDPRChanges"
              maxlength="40"
            />
          </div>
          <div class="form-group col-md-3 ba-box-input">
            <label for="positionResetCookies">{{$t("ct-gdpr-position")}}</label>
            <select
              id="positionResetCookies"
              class="ba-select ba-md"
              v-model="positionResetCookies"
              @change="applyGDPRChanges"
            >
              <option value="left">{{ $t("ct-left") }}</option>
              <option value="right">{{ $t("ct-right") }}</option>
            </select>
          </div>
        </div>

        <div class="row">
          <div class="form-group col-md-3">
            <label for="pickerbuttonColorResetCookies">
              {{ $t("ct-gdpr-button-color") }}
            </label>
            <div
              class="colorpicker"
              id="pickerbuttonColorResetCookies"
              @click="togglePicker('displayPickerbuttonColorResetCookies')"
            >
              <div>
                <div
                  :style="'background-color: ' + buttonColorResetCookies + ';'"
                ></div>
              </div>
              <span>{{ buttonColorResetCookies }}</span>
            </div>
            <sketch-picker
              v-show="displayPickerbuttonColorResetCookies"
              :color="buttonColorResetCookies"
              v-model="buttonColorResetCookies"
              @input="changeValue($event, 'buttonColorResetCookies')"
            />
          </div>

          <div class="form-group col-md-3">
            <label for="pickerbuttonBackgroundResetCookies">
              {{ $t("ct-gdpr-button-background") }}
            </label>
            <div
              class="colorpicker"
              id="pickerbuttonBackgroundResetCookies"
              @click="togglePicker('displayPickerbuttonBackgroundResetCookies')"
            >
              <div>
                <div
                  :style="
                    'background-color: ' + buttonBackgroundResetCookies + ';'
                  "
                ></div>
              </div>
              <span>{{ buttonBackgroundResetCookies }}</span>
            </div>
            <sketch-picker
              v-show="displayPickerbuttonBackgroundResetCookies"
              :color="buttonBackgroundResetCookies"
              v-model="buttonBackgroundResetCookies"
              @input="changeValue($event, 'buttonBackgroundResetCookies')"
            />
          </div>

          <div class="form-group col-md-3">
            <label for="pickerborderColorResetCookies">
              {{ $t("ct-border") }}
            </label>
            <div
              class="colorpicker"
              id="pickerborderColorResetCookies"
              @click="togglePicker('displayPickerborderColorResetCookies')"
            >
              <div>
                <div
                  :style="
                    'background-color: ' + colorValuePickerResetCookies + ';'
                  "
                ></div>
              </div>
              <span>{{ colorValuePickerResetCookies }}</span>
            </div>
            <sketch-picker
              v-show="displayPickerborderColorResetCookies"
              :color="colorValuePickerResetCookies"
              v-model="colorValuePickerResetCookies"
              @input="changeValue($event, 'colorValuePickerResetCookies')"
            />
          </div>
        </div>

        <div class="row">
          <div class="form-group col-8 col-md-4 ba-box-input">
            <label for="borderStyleResetCookies">{{$t("ct-gdpr-border-type")}}</label>
            <select
              id="borderStyleResetCookies"
              class="ba-select ba-md"
              v-model="borderStyleResetCookies"
              @change="setBorder"
            >
              <option
                v-for="type in borderStyleOptions"
                :key="type"
                :value="type"
                v-text="type"
              />
            </select>
          </div>
          <div class="form-group col-4 col-md-2 ba-box-input">
            <label for="borderSizeResetCookies">{{
                $t("ct-gdpr-thickness")
              }}</label>
            <input
              id="borderSizeResetCookies"
              type="number"
              v-model="borderSizeResetCookies"
              class="ba-input ba-md"
              @input="setBorder"
              min="0"
              max="100"
            />
          </div>
        </div>

        <div class="row">
          <div class="row col-12">
            <p class="col-12">{{ $t("ct-radius") }}</p>
            <div class="form-group col-3 col-md-1">
              <input
                type="number"
                v-model="borderRoudV1"
                class="form-control ba-input ba-md"
                @input="setBorderRadius"
                min="0"
                max="100"
              />
            </div>
            <div
              class="bordeup"
              :style="{
                'border-top-left-radius': borderRoudV1 + 'px',
                'border-top-right-radius': borderRoudV2 + 'px',
              }"
            ></div>
            <div class="form-group col-3 col-md-1">
              <input
                type="number"
                v-model="borderRoudV2"
                class="form-control ba-input ba-md"
                @input="setBorderRadius"
                min="0"
                max="100"
              />
            </div>
          </div>
          <div class="row col-12">
            <div class="form-group col-3 col-md-1">
              <input
                type="number"
                v-model="borderRoudV4"
                class="form-control ba-input ba-md"
                @input="setBorderRadius"
                min="0"
                max="100"
              />
            </div>
            <div
              class="bordedown"
              :style="{
                'border-bottom-left-radius': borderRoudV4 + 'px',
                'border-bottom-right-radius': borderRoudV3 + 'px',
              }"
            ></div>
            <div class="form-group col-3 col-md-1">
              <input
                type="number"
                v-model="borderRoudV3"
                class="form-control ba-input ba-md"
                @input="setBorderRadius"
                min="0"
                max="100"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { get as getWebsite } from "../../../js/services/editor/website";
import {
  getWebsiteConfig,
  setWebsiteConfig,
} from "./../../../js/services/editor/configManager";
import Errors from "../../../js/base/Errors";

import FontGroupEdition from "../../editor/base/sidebar/FontGroupEdition";

export default {
  name: "GDPRSettings",
  data() {
    return {
      errors: new Errors(),
      image: {
        show: false,
        layout: null,
      },
      fontFamilies: FontGroupEdition.data().options,
      fontSizes: _.range(6, 23),
      website: {},
      categories: {},
      languages: {},
      configuration: {
        description: "",
        image: "",
        tab_color: "",
        title_separator: "|",
        title_order: 0,
      },
      scriptLayout: {
        script: "",
        script_pixel: "",
        script_analytics: "",
      },
      menuNavBar: [
        {
          text: "Meus Sites",
          link: "Home",
          router: true,
          active: false,
          target: false,
          current: false,
        },
      ],

      displayPickerbackgroundColor: false,
      displayPickercolorTitle: false,
      displayPickercolorParagraph: false,
      displayPickercolorLink: false,
      displayPickerbuttonBackground: false,
      displayPickerbuttonColor: false,
      displayPickerbuttonAdvBackground: false,
      displayPickerbuttonAdvColor: false,
      displayPickerbuttonBackgroundResetCookies: false,
      displayPickerbuttonColorResetCookies: false,
      displayPickerborderColorResetCookies: false,
      borderResetCookies: "1 solid #000000",
      borderRadiusResetCookies: "0 0 0 0",
      colorValuePickerResetCookies: "#FFFFFF",
      colorValuePickerResetCookies1: "#FFFFFF",
      colorValuePickerResetCookies2: "#FFFFFF",

      active: false,
      activeResetCookies: false,
      title: "Cookies & Privacy",
      message:
        "This website uses cookies to ensure you get the best experience on our website.",
      expires: 30,
      cookieTypes: {
        preferences: {
          type: "Site Preferences",
          value: "preferences",
          description:
            "These are cookies that are related to your site preferences, e.g. remembering your username, site colours, etc.",
        },
        analytics: {
          type: "Analytics",
          value: "analytics",
          description: "Cookies related to site visits, browser types, etc.",
        },
        marketing: {
          type: "Marketing",
          value: "marketing",
          description:
            "Cookies related to marketing, e.g. newsletters, social media, etc",
        },
      },
      link: "/privacy/",
      uncheckBoxes: true,
      moreInfoLabel: "More informations",
      acceptBtnLabel: "Accept Cookies",
      onlyBtnLabel: "Only Necessary",
      advancedBtnLabel: "Customise Cookies",
      cookieTypesTitle: "Select cookies to accept",
      fixedCookieTypeLabel: "Necessary",
      fixedCookieTypeDesc:
        "These are cookies that are essential for the website to work correctly.",
      backgroundColor: "#FFFFFF",
      colorTitle: "#37187f",
      colorParagraph: "#383838",
      colorLink: "#21309b",
      buttonBackground: "#1f4efe",
      buttonColor: "#e3e3f2",
      buttonAdvBackground: "#e3e3f2",
      buttonAdvColor: "#e3e3f2",
      position: "bottom-right",
      btnLabelResetCookies: "Reset Cookies",
      buttonColorResetCookies: "#FFFFFF",
      buttonBackgroundResetCookies: "#FF1F19",
      positionResetCookies: "right",

      borderSizeResetCookies: "0",
      borderStyleResetCookies: "none",
      borderStyleOptions: ["none", "dotted", "dashed", "solid", "double"],
      borderRoudV1: "0",
      borderRoudV2: "0",
      borderRoudV3: "0",
      borderRoudV4: "0",

      fonts: {
        title: {
          fontFamily: "",
          fontSize: "",
        },
        message: {
          fontFamily: "",
          fontSize: "",
        },
        acceptBtnLabel: {
          fontFamily: "",
          fontSize: "",
        },
        onlyBtnLabel: {
          fontFamily: "",
          fontSize: "",
        },
        moreInfoLabel: {
          fontFamily: "",
          fontSize: "",
        },
        advancedBtnLabel: {
          fontFamily: "",
          fontSize: "",
        },
        cookieTypesTitle: {
          fontFamily: "",
          fontSize: "",
        },
      },
    };
  },

  methods: {

    reloadLanguage() {

      this.title = this.$t('gdpr-title-app');
      this.message = this.$t('gdpr-message-app');
      this.moreInfoLabel = this.$t('gdpr-more-info-label-app');
      this.acceptBtnLabel = this.$t('gdpr-accept-btn-label-app');
      this.onlyBtnLabel = this.$t('gdpr-only-btn-label-app');
      this.advancedBtnLabel = this.$t('gdpr-advanced-btn-label-app');
      this.cookieTypesTitle = this.$t('gdpr-cookie-types-title-app');
      this.fixedCookieTypeLabel = this.$t('gdpr-fixed-cookie-type-label-app');
      this.fixedCookieTypeDesc = this.$t('gdpr-fixed-cookie-type-desc-app');
      this.cookieTypes.preferences.type = this.$t('gdpr-cookie-types-preferences-type-app');
      this.cookieTypes.preferences.description = this.$t('gdpr-cookie-types-preferences-desc-app');
      this.cookieTypes.analytics.type = this.$t('gdpr-cookie-types-analytics-type-app');
      this.cookieTypes.analytics.description = this.$t('gdpr-cookie-types-analytics-desc-app');
      this.cookieTypes.marketing.type = this.$t('gdpr-cookie-types-marketing-type-app');
      this.cookieTypes.marketing.description = this.$t('gdpr-cookie-types-marketing-desc-app');

      this.$snotify.success(this.$t('ct-language-success'));

      this.applyGDPRChanges();
    },

    setBorder() {
      if (this.borderSizeResetCookies > 100) {
        this.borderSizeResetCookies = 100;
      } else if (this.borderSizeResetCookies < 0) {
        this.borderSizeResetCookies = 0;
      }

      this.borderResetCookies = `${this.borderSizeResetCookies} ${this.borderStyleResetCookies} ${this.colorValuePickerResetCookies}`;
    },

    setBorderRadius() {
      if (this.borderRoudV1 > 100) {
        this.borderRoudV1 = 100;
      } else if (this.borderRoudV1 < 0) {
        this.borderRoudV1 = 0;
      }
      if (this.borderRoudV2 > 100) {
        this.borderRoudV2 = 100;
      } else if (this.borderRoudV2 < 0) {
        this.borderRoudV2 = 0;
      }
      if (this.borderRoudV3 > 100) {
        this.borderRoudV3 = 100;
      } else if (this.borderRoudV3 < 0) {
        this.borderRoudV3 = 0;
      }
      if (this.borderRoudV4 > 100) {
        this.borderRoudV4 = 100;
      } else if (this.borderRoudV4 < 0) {
        this.borderRoudV4 = 0;
      }

      this.borderRadiusResetCookies = `${this.borderRoudV1} ${this.borderRoudV2} ${this.borderRoudV3} ${this.borderRoudV4}`;
    },

    changeValue($e, where) {
      this[where] = $e.hex8;
      this.applyGDPRChanges();
    },

    togglePicker(where) {
      if (where != "displayPickerbackgroundColor")
        this.displayPickerbackgroundColor = false;
      if (where != "displayPickercolorTitle")
        this.displayPickercolorTitle = false;
      if (where != "displayPickercolorParagraph")
        this.displayPickercolorParagraph = false;
      if (where != "displayPickercolorLink")
        this.displayPickercolorLink = false;
      if (where != "displayPickerbuttonBackground")
        this.displayPickerbuttonBackground = false;
      if (where != "displayPickerbuttonColor")
        this.displayPickerbuttonColor = false;
      if (where != "displayPickerbuttonAdvBackground")
        this.displayPickerbuttonAdvBackground = false;
      if (where != "displayPickerbuttonAdvColor")
        this.displayPickerbuttonAdvColor = false;
      if (where != "displayPickerbuttonColorResetCookies")
        this.displayPickerbuttonColorResetCookies = false;
      if (where != "displayPickerbuttonBackgroundResetCookies")
        this.displayPickerbuttonBackgroundResetCookies = false;
      if (where != "displayPickerborderColorResetCookies")
        this.displayPickerborderColorResetCookies = false;

      this[where] = !this[where];
    },

    valuesGDR(data) {
      this.active = data["active"];
      this.title = data["title"];
      this.message = data["message"];
      this.moreInfoLabel = data["moreInfoLabel"];
      this.acceptBtnLabel = data["acceptBtnLabel"];
      this.onlyBtnLabel = data["onlyBtnLabel"];
      this.advancedBtnLabel = data["advancedBtnLabel"];
      this.cookieTypesTitle = data["cookieTypesTitle"];
      this.fixedCookieTypeLabel = data["fixedCookieTypeLabel"];
      this.link = data["link"];
      this.fixedCookieTypeDesc = data["fixedCookieTypeDesc"];
      this.cookieTypes.preferences.type = data["cookieTypes.preferences.type"];
      this.cookieTypes.preferences.description =
        data["cookieTypes.preferences.description"];
      this.cookieTypes.analytics.type = data["cookieTypes.analytics.type"];
      this.cookieTypes.analytics.description =
        data["cookieTypes.analytics.description"];
      this.cookieTypes.marketing.type = data["cookieTypes.marketing.type"];
      this.cookieTypes.marketing.description =
        data["cookieTypes.marketing.description"];
      this.backgroundColor = data["backgroundColor"];
      this.colorTitle = data["colorTitle"];
      this.colorParagraph = data["colorParagraph"];
      this.colorLink = data["colorLink"];
      this.buttonBackground = data["buttonBackground"];
      this.buttonColor = data["buttonColor"];
      this.buttonAdvBackground = data["buttonAdvBackground"];
      this.buttonAdvColor = data["buttonAdvColor"];
      this.position = data["position"];
      this.btnLabelResetCookies = data["btnLabelResetCookies"];
      this.buttonBackgroundResetCookies = data["buttonBackgroundResetCookies"];
      this.buttonColorResetCookies = data["buttonColorResetCookies"];
      this.positionResetCookies = data["positionResetCookies"]
        ? data["positionResetCookies"]
        : "right";
      this.activeResetCookies = data["activeResetCookies"]
        ? data["activeResetCookies"]
        : false;

      this.borderResetCookies = data["borderResetCookies"];
      this.borderRadiusResetCookies = data["borderRadiusResetCookies"];
      this.colorValuePickerResetCookies = data["colorValuePickerResetCookies"];
      this.colorValuePickerResetCookies1 =
        data["colorValuePickerResetCookies1"];
      this.colorValuePickerResetCookies2 =
        data["colorValuePickerResetCookies2"];

      if (!!data["fonts"]) {
        this.fonts = data["fonts"];
      }

      if (data["borderResetCookies"]) {
        let value = this.borderResetCookies.split(" ");

        this.borderSizeResetCookies = parseInt(value[0]);
        this.borderStyleResetCookies = value[1];
      }

      if (data["borderRadiusResetCookies"]) {
        let value = this.borderRadiusResetCookies.split(" ");

        this.borderRoudV1 = parseInt(value[0]);
        this.borderRoudV2 = parseInt(value[1]);
        this.borderRoudV3 = parseInt(value[2]);
        this.borderRoudV4 = parseInt(value[3]);
      }
    },

    saveSettings() {
      let obj = {
        website_id: this.$route.params.id,
        key: "gdprSettings",
        value: JSON.stringify({
          active: this.active,
          title: this.title,
          message: this.message,
          moreInfoLabel: this.moreInfoLabel,
          acceptBtnLabel: this.acceptBtnLabel,
          onlyBtnLabel: this.onlyBtnLabel,
          advancedBtnLabel: this.advancedBtnLabel,
          cookieTypesTitle: this.cookieTypesTitle,
          link: this.link,
          fixedCookieTypeLabel: this.fixedCookieTypeLabel,
          fixedCookieTypeDesc: this.fixedCookieTypeDesc,
          "cookieTypes.preferences.type": this.cookieTypes.preferences.type,
          "cookieTypes.preferences.description":
          this.cookieTypes.preferences.description,
          "cookieTypes.analytics.type": this.cookieTypes.analytics.type,
          "cookieTypes.analytics.description":
          this.cookieTypes.analytics.description,
          "cookieTypes.marketing.type": this.cookieTypes.marketing.type,
          "cookieTypes.marketing.description":
          this.cookieTypes.marketing.description,
          backgroundColor: this.backgroundColor,
          colorTitle: this.colorTitle,
          colorParagraph: this.colorParagraph,
          colorLink: this.colorLink,
          buttonBackground: this.buttonBackground,
          buttonColor: this.buttonColor,
          buttonAdvBackground: this.buttonAdvBackground,
          buttonAdvColor: this.buttonAdvColor,
          position: this.position,
          btnLabelResetCookies: this.btnLabelResetCookies,
          buttonBackgroundResetCookies: this.buttonBackgroundResetCookies,
          buttonColorResetCookies: this.buttonColorResetCookies,
          positionResetCookies: this.positionResetCookies,
          borderResetCookies: this.borderResetCookies,
          borderRadiusResetCookies: this.borderRadiusResetCookies,
          colorValuePickerResetCookies: this.colorValuePickerResetCookies,
          colorValuePickerResetCookies1: this.colorValuePickerResetCookies1,
          colorValuePickerResetCookies2: this.colorValuePickerResetCookies2,
          activeResetCookies: this.activeResetCookies,
          fonts: this.fonts,
        }),
      };
      setWebsiteConfig(obj).then((data) => {
        this.$snotify.success(this.$t("success"));
      });
    },

    eraseCookieFromAllPaths(name) {
      // This function will attempt to remove a cookie from all paths.
      var pathBits = location.pathname.split("/");
      var pathCurrent = " path=";

      // do a simple pathless delete first.
      document.cookie = name + "=; expires=Thu, 01-Jan-1970 00:00:01 GMT;";

      for (var i = 0; i < pathBits.length; i++) {
        pathCurrent += (pathCurrent.substr(-1) != "/" ? "/" : "") + pathBits[i];
        document.cookie =
          name +
          "=; expires=Thu, 01-Jan-1970 00:00:01 GMT;" +
          pathCurrent +
          ";";
      }
    },

    applyGDPRChanges() {
      let vm = this;
      vm.eraseCookieFromAllPaths("cookieControl");

      $("#gdpr-cookie-message").detach();

      document.body.style.setProperty(
        "--backgroundColor",
        this.backgroundColor
      );
      document.body.style.setProperty("--colorTitle", this.colorTitle);
      document.body.style.setProperty("--colorParagraph", this.colorParagraph);
      document.body.style.setProperty("--colorLink", this.colorLink);
      document.body.style.setProperty(
        "--buttonBackground",
        this.buttonBackground
      );
      document.body.style.setProperty("--buttonColor", this.buttonColor);
      document.body.style.setProperty(
        "--buttonAdvBackground",
        this.buttonAdvBackground
      );
      document.body.style.setProperty("--buttonAdvColor", this.buttonAdvColor);
      document.body.style.setProperty(
        "--btnLabelResetCookies",
        this.btnLabelResetCookies
      );
      document.body.style.setProperty(
        "--buttonBackgroundResetCookies",
        this.buttonBackgroundResetCookies
      );
      document.body.style.setProperty(
        "--buttonColorResetCookies",
        this.buttonColorResetCookies
      );

      $(".container-wrapper").ihavecookies({
        title: vm.title,
        message: vm.message,
        expires: vm.expires,
        cookieTypes: vm.cookieTypes,
        link: vm.link,
        moreInfoLabel: vm.moreInfoLabel,
        acceptBtnLabel: vm.acceptBtnLabel,
        onlyBtnLabel: vm.onlyBtnLabel,
        advancedBtnLabel: vm.advancedBtnLabel,
        uncheckBoxes: true,
        cookieTypesTitle: vm.cookieTypesTitle,
        fixedCookieTypeLabel: vm.fixedCookieTypeLabel,
        fixedCookieTypeDesc: vm.fixedCookieTypeDesc,
        onAccept: function () {
          var myPreferences = $.fn.ihavecookies.cookie();
          console.log(myPreferences);
        },
      });

      if (this.displayPickerbuttonColorResetCookies)
        this.displayPickerbuttonColorResetCookies = false;
      if (this.displayPickerbuttonBackgroundResetCookies)
        this.displayPickerbuttonBackgroundResetCookies = false;

      setTimeout(function () {
        $("#gdpr-cookie-message").addClass(vm.position);
        $("#gdpr-cookie-advanced").on("click", function () {
          setTimeout(function () {
            $("#gdpr-cookietype-analytics").prop("checked", true);
            $("#gdpr-cookietype-preferences").prop("checked", true);
            $("#gdpr-cookietype-marketing").prop("checked", true);
          }, 1000);
        });
      }, 2000);
    },
  },

  //mounted() {
  created() {
    this.$root.$on("toggleColorPickerSite", (value) => {
      this.togglePicker(value);
    });

    let vm = this;
    getWebsite(this.$route.params.id)
      .then((website) => {
        this.website = website.data;

        getWebsiteConfig(this.$route.params.id).then(async (data) => {
          if (typeof data.data.gdprSettings !== "undefined") {
            await vm.valuesGDR(JSON.parse(data.data.gdprSettings.value));
            setTimeout(function () {
              vm.applyGDPRChanges();
              vm.$loading.hide();
            }, 2000);
          }
        });
      })
      .catch((error) => {
        console.warn(error);
        if (error.response.data.errors)
          this.errors.record({ website: error.response.data.errors });
      });
  },
};
</script>

<style lang="scss" scoped>
h2 {
  font-size: 20px;
  color: #0080fc;
  font-weight: 700;
  margin-top: 25px;
}

.card-header {
  background: #f7f7f7;

  .custom-checkbox {
    align-self: center;

    label {
      font-size: 20px;

      span {
        margin-left: 10px;
      }
    }

    .custom-control-label::before,
    .custom-control-label::after {
      width: 1.25rem;
      height: 1.25rem;
      top: 0.35rem;
      cursor: pointer;
    }
  }
}

.card-content {
  p:first-child {
    font-family: Montserrat;
    font-size: 14px;
    font-weight: 600;
    line-height: 21px;
    color: #4D5D71;
    margin-bottom: 8px;
  }

  input,
  textarea,
  select {
    font-size: 14px;
    padding-left: 15px;
    font-weight: 600;
    font-family: Muli;
  }

  textarea {
    resize: none;
  }

  .colorpicker {
    display: grid;
    grid-template-columns: auto 1fr;
    gap: 16px;
    border-radius: 3px;

    > div {
      background: #EFF2F8;
      padding: 10px;
      border-radius: 8px;

      div {
        border-radius: 4px;
        height: 100%;
        width: 30px;
        height: 30px;
      }
    }

    span {
      font-family: Montserrat;
      font-size: 12px;
      font-weight: 500;
      line-height: 18px;
      background-color: #EFF2F8;
      height: 100%;
      border-radius: 8px;
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 8px;
      color: rgba(66, 94, 125, 0.5);
    }
  }

  .vc-sketch {
    position: absolute;
    z-index: 1;
  }

  .bordeup,
  .bordedown {
    border: 1px solid #000;
    height: 50px;
    width: 100px;
  }

  .bordeup {
    border-bottom: none;
  }

  .bordedown {
    border-top: none;
  }

  > .row {
    margin-bottom: 10px;
  }
}

.ba-switch{
  margin-bottom: 0;
}

.ba-box-input, .form-group:has(.colorpicker){
  label{
    font-family: Montserrat;
    font-size: 14px;
    font-weight: 500;
    line-height: 21px;
    color: #111827;
    margin-bottom: 0;
  }
}

.ba-select{
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/dashboard/pages/GDPRSettings.vue